export var Currency = function (Currency) {
  Currency["EUR"] = "\u20AC";
  Currency["EUR_NAME"] = "EUR";
  Currency["EUR_CODE"] = "978";
  Currency["GBP"] = "\xA3";
  Currency["GBP_NAME"] = "GBP";
  Currency["GBP_CODE"] = "826";
  return Currency;
}({});